
<ngx-spinner
  bdColor="#ffffff94"
  size="medium"
  color="#5d5bd7"
  type="ball-atom"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<router-outlet *ngIf="phasesCheckDone"></router-outlet>
